import {
	enumOrDefault,
	IModel,
	IVIPDocumentBase,
	VIPDocumentBase,
} from "@/loader";
import dayjs from "dayjs";
import { Duration } from "dayjs/plugin/duration";


export enum VIPDocumentCategory {
	miscellaneous = 0,
	k_bis = 1,
	carte_professionnelle = 2,
	attestation_de_regularite_fiscale = 3,
	attestation_ursaff = 4,
	attestation_conges_payes_et_chomage = 5,
	cotation_banque_de_france = 6,
	dernier_bilan_comptable = 7,
	competences_et_engagements = 8,
	liste_des_effectifs = 9,
	liste_des_materiels_mobilises = 10,
	liste_des_etablissements_secondaires = 11,
	label_canalisateur = 12,
	certificat_iso_9001 = 13,
	certificat_iso_14001 = 14,
	certificat_iso_45001 = 15,
	attestation_d_assurance_rc = 16,
	attestation_d_assurance_rdgc = 17,
	plaquette_commerciale = 18,
}

export const VIPDocumentCategoryUnique = [
	VIPDocumentCategory.k_bis,
	VIPDocumentCategory.carte_professionnelle,
	VIPDocumentCategory.attestation_de_regularite_fiscale,
	VIPDocumentCategory.attestation_ursaff,
	VIPDocumentCategory.attestation_conges_payes_et_chomage,
	VIPDocumentCategory.cotation_banque_de_france,
	VIPDocumentCategory.dernier_bilan_comptable,
	VIPDocumentCategory.competences_et_engagements,
	VIPDocumentCategory.liste_des_effectifs,
	VIPDocumentCategory.liste_des_materiels_mobilises,
	VIPDocumentCategory.liste_des_etablissements_secondaires,
	VIPDocumentCategory.label_canalisateur,
	VIPDocumentCategory.certificat_iso_9001,
	VIPDocumentCategory.certificat_iso_14001,
	VIPDocumentCategory.certificat_iso_45001,
	VIPDocumentCategory.attestation_d_assurance_rc,
	VIPDocumentCategory.attestation_d_assurance_rdgc,
	VIPDocumentCategory.plaquette_commerciale,
];

export function VIPDocumentCategoryOrDefault(value: any, defaultValue: VIPDocumentCategory = VIPDocumentCategory.miscellaneous): VIPDocumentCategory {
	return <VIPDocumentCategory>enumOrDefault(value, defaultValue, Object.values(VIPDocumentCategory));
}

export function getVIPDocumentCategoryLabel(value: VIPDocumentCategory): string {
	switch (value) {
		case VIPDocumentCategory.miscellaneous:
			return window.wp.i18n._x('Divers', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.k_bis:
			return window.wp.i18n._x('K-Bis', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.carte_professionnelle:
			return window.wp.i18n._x('Carte Professionnelle', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.attestation_de_regularite_fiscale:
			return window.wp.i18n._x('Attestation de régularité fiscale', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.attestation_ursaff:
			return window.wp.i18n._x('Attestation URSAFF', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.attestation_conges_payes_et_chomage:
			return window.wp.i18n._x('Attestation Congés payés et chômage…', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.cotation_banque_de_france:
			return window.wp.i18n._x('Cotation Banque de France', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.dernier_bilan_comptable:
			return window.wp.i18n._x('Dernier bilan comptable', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.competences_et_engagements:
			return window.wp.i18n._x('Compétences et engagements', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.liste_des_effectifs:
			return window.wp.i18n._x('Liste des effectifs', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.liste_des_materiels_mobilises:
			return window.wp.i18n._x('Liste des matériels mobilisés', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.liste_des_etablissements_secondaires:
			return window.wp.i18n._x('Liste des établissements secondaires', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.label_canalisateur:
			return window.wp.i18n._x('Label canalisateur', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.certificat_iso_9001:
			return window.wp.i18n._x('Certificat ISO-9001', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.certificat_iso_14001:
			return window.wp.i18n._x('Certificat ISO-14001', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.certificat_iso_45001:
			return window.wp.i18n._x('Certificat ISO-45001', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.attestation_d_assurance_rc:
			return window.wp.i18n._x('Attestation d’assurance RC', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.attestation_d_assurance_rdgc:
			return window.wp.i18n._x('Attestation d’assurance RDGC', 'DocumentCategory', "vip-vue");
		case VIPDocumentCategory.plaquette_commerciale:
			return window.wp.i18n._x('Plaquette commerciale', 'DocumentCategory', "vip-vue");
	}
}

export function getVIPDocumentCategoryList(): { value: any, text: string }[] {
	return [
		{ value: Number(VIPDocumentCategory.miscellaneous), text: window.wp.i18n._x('Divers', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.k_bis), text: window.wp.i18n._x('K-Bis', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.carte_professionnelle), text: window.wp.i18n._x('Carte Professionnelle', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.attestation_de_regularite_fiscale), text: window.wp.i18n._x('Attestation de régularité fiscale', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.attestation_ursaff), text: window.wp.i18n._x('Attestation URSAFF', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.attestation_conges_payes_et_chomage), text: window.wp.i18n._x('Attestation Congés payés et chômage…', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.cotation_banque_de_france), text: window.wp.i18n._x('Cotation Banque de France', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.dernier_bilan_comptable), text: window.wp.i18n._x('Dernier bilan comptable', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.competences_et_engagements), text: window.wp.i18n._x('Compétences et engagements', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.liste_des_effectifs), text: window.wp.i18n._x('Liste des effectifs', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.liste_des_materiels_mobilises), text: window.wp.i18n._x('Liste des matériels mobilisés', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.liste_des_etablissements_secondaires), text: window.wp.i18n._x('Liste des établissements secondaires', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.label_canalisateur), text: window.wp.i18n._x('Label canalisateur', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.certificat_iso_9001), text: window.wp.i18n._x('Certificat ISO-9001', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.certificat_iso_14001), text: window.wp.i18n._x('Certificat ISO-14001', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.certificat_iso_45001), text: window.wp.i18n._x('Certificat ISO-45001', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.attestation_d_assurance_rc), text: window.wp.i18n._x('Attestation d’assurance RC', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.attestation_d_assurance_rdgc), text: window.wp.i18n._x('Attestation d’assurance RDGC', 'DocumentCategory', "vip-vue") },
		{ value: Number(VIPDocumentCategory.plaquette_commerciale), text: window.wp.i18n._x('Plaquette commerciale', 'DocumentCategory', "vip-vue") },
	].sort((a, b) => a.text.localeCompare(b.text));
}

/**
 * Document Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.0.0
 * @since		1.0.0
 */
export interface IVIPDocument extends IVIPDocumentBase {
}

/**
 * Document Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.0.0
 * @since		1.0.0
 */
export class VIPDocument extends VIPDocumentBase implements IVIPDocument, IModel<IVIPDocument> {
	constructor (data: IVIPDocument = {}) {
		super(data);
	}

	public get is_expired(): boolean {
		return this.date_expiration ? this.date_expiration.isBefore(dayjs()) : false;
	}

	public get ago(): Duration | null {
		return this.date_creation ? dayjs.duration(this.date_creation.diff(dayjs())) : null;
	}

	public get until(): Duration | null {
		return this.date_expiration ? dayjs.duration(this.date_expiration.diff(dayjs())) : null;
	}

	public get categoryName(): string {
		return this.category ? getVIPDocumentCategoryLabel(this.category) : "";
	}

	public load(data: IVIPDocument) {
		super.load(data);
	}

	public update(data: IVIPDocument) {
		super.update(data);
	}

	public documentUrl(token: string) {
		return `/?document=${this.id}&token=${token}`;
	}
}
